import { Component, OnInit, ViewChild } from '@angular/core';
import { Log } from 'ng2-logger';
import { LiftCreateModalComponent } from '../../components/lift-create-modal/lift-create-modal.component';
import { TableConfig } from '@app/shared/util/table-config.utils';
import { Lift } from '@models/lift.model';
import { ActivatedRoute, Router } from '@angular/router';
import * as LiftActions from '../../store/lifts.actions';
import * as LiftReducer from '../../store/lifts.reducer';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { debounceTime, filter } from 'rxjs/operators';
import { AddLiftAction, LoadPlantsAction } from '../../store/lifts.actions';
import { Plant } from '@models/plant.model';
import { PagedResponse } from "@models/response.model";
import * as _ from "lodash";
import { FormBuilder, FormControl, Validators } from "@angular/forms";
import { Line } from "@models/line.model";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";

@UntilDestroy()
@Component({
    selector: 'app-lifts',
    templateUrl: './lifts-list.component.html',
    styleUrls: ['./lifts-list.component.scss']
})
export class LiftsListComponent implements OnInit {
    _logger = Log.create(LiftsListComponent.name);

    @ViewChild(LiftCreateModalComponent, {static: true}) liftCreateModal: LiftCreateModalComponent;

    config = new TableConfig();

    lifts: Array<Lift> = [];

    lifts$: Observable<PagedResponse<Lift>>;
    isLoadingLifts$: Observable<boolean>;
    plants$: Observable<Plant[]>;
    lines$: Observable<Line[]>;
    filtersExpanded = true;
    filterForm;

    constructor(private fb: FormBuilder,
                private store: Store<any>,
                private route: ActivatedRoute,
                private router: Router) {

        this.filterForm = this.fb.group({
            search: [null],
            toolUID: [null],
            toolName: [null],
            line: [null]
        });

        this.loadLines();
        this.getFirstPageOfLifts();

        this.lifts$ = this.store.pipe(select(LiftReducer.getLifts), filter(lifts => !!lifts));
        this.isLoadingLifts$ = this.store.pipe(select(LiftReducer.isLoadingLifts));
        this.plants$ = this.store.pipe(select(LiftReducer.getPlants), filter(plants => !!plants));
        this.lines$ = this.store.pipe(select(LiftReducer.getLines), filter(lines => !!lines));

        this.filterForm.valueChanges.pipe(debounceTime(300), untilDestroyed((this))).subscribe(newValue => {
            this.onFilterChange(newValue);
        });
    }

    private getFirstPageOfLifts() {
        this.config.pager.page = 1;
        this.config.pager.pageSize = 20;
        this.store.dispatch(new LiftActions.LoadLiftsAction(this.config));
    }

    ngOnInit() {
    }

    filterControl(name: string) {
        return this.filterForm.get(name) as FormControl;
    }

    onAddLiftButtonClick() {
        this.store.dispatch(new LoadPlantsAction());
        this.liftCreateModal.open();
    }

    onSelectLiftClick(lift: Lift) {
        const filters = this.filterForm.value;
        this.router.navigate([`${lift.id}`], {
            relativeTo: this.route,
            queryParams: {
                toolUID: filters.toolUID || null,
                toolName: filters.toolName || null,
                lineId: filters.line?.id || null
            }
        });
    }

    onOpenLiftInNewTab(lift: Lift) {
        const filters = this.filterForm.value;
        const urlTree = this.router.createUrlTree([`${lift.id}`], {
            relativeTo: this.route,
            queryParams: {
                toolUID: filters.toolUID || null,
                toolName: filters.toolName || null,
                lineId: filters.line?.id || null
            }
        });
        localStorage.setItem('openedInNewTab', 'true');
        window.open(this.router.serializeUrl(urlTree), '_blank', 'noopener');
    }

    onScrollReachEnd(config: TableConfig) {
        config.pager.page = config.pager.page + 1;
        this.store.dispatch(new LiftActions.LoadLiftsAction(this.config));
    }

    onFilterChange(newValue) {
        const clone = _.cloneDeep(this.config);

        if (newValue.search) {
            clone.upsertFilter('name', newValue?.search);
        } else {
            clone.removeFilter('name');
        }

        if (newValue.toolUID) {
            clone.upsertFilter('toolUID', newValue?.toolUID);
        } else {
            clone.removeFilter('toolUID');
        }

        if (newValue.toolName) {
            clone.upsertFilter('toolName', newValue?.toolName);
        } else {
            clone.removeFilter('toolName');
        }

        if (newValue.line && newValue.line.id != null) {
            clone.upsertFilter('lineId', newValue?.line?.id);
        } else {
            clone.removeFilter('lineId');
        }

        this.config = clone;

        this.getFirstPageOfLifts();
    }

    onCreateLift(lift: Lift) {
        this.store.dispatch(new AddLiftAction(lift));
        this.liftCreateModal.close();
    }

    loadLines() {
        this.store.dispatch(new LiftActions.LoadLinesAction());
    }


    onFilter(tableConfig: TableConfig) {

    }

    toggleFilters() {
        this.filtersExpanded = !this.filtersExpanded;
    }
}
